<pp-settings-container>
  <pp-settings-header>
    <header class="settingsSite__header">
      <div class="settingsSite__siteName">
        <pp-account-name [ppAccount]="account" [ppDisabled]="isAccountAdmin" />
      </div>

      <div class="settingsAccount__lowerBar">
        <pp-account-settings-tabs [ppAccountId]="accountId" />

        @if (url.includes(EAccountSettingsTabPath.USER_MANAGEMENT)) {
          <pp-account-user-management-header-buttons
            [ppAccountId]="account?.accountId"
          ></pp-account-user-management-header-buttons>
        }

        @if (url.includes(EAccountSettingsTabPath.SITES)) {
          <pp-account-sites-header-buttons
            [ppAccountId]="account?.accountId"
          ></pp-account-sites-header-buttons>
        }
      </div>
    </header>
  </pp-settings-header>

  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</pp-settings-container>
